<template>
    <div class="commonAgreement_contaier">
        <div class="agreement_main">
            <h1>“产科速讯”学科学术交流项目</h1>
            <h3>劳务协议</h3>
            <p class="">甲方：<span class="agreement_underline">北京光明慈善基金会</span></p>
            <p class="">乙方：<span class="agreement_underline">{{ data.doctor_name }}</span></p>
            <p class="">身份证号：<span class="agreement_underline">{{ data.doctor_id_card_number }}</span></p>
            <p class="">职务：<span class="agreement_underline">{{ data.resume }}</span></p>
            <p class="">电话：<span class="agreement_underline">{{ data.doctor_phone }}</span></p>
            <p class="">银行卡号：<span class="agreement_underline">{{ data.doctor_bank_number }}</span></p>
            <p class="">开户行：<span class="agreement_underline">{{ data.doctor_bank }}</span></p>
            <p class="agreement-abstract agreement_row_p">近年来，母婴健康和分娩安全已经成为公共卫生领域的核心议题，尤其是在高龄产妇增多、出生率下降及高危妊娠的管理方面，产科诊疗和母胎管理的个性化、精准化需求愈发突出。随着女性生育年龄的推迟，高龄产妇的比例持续上升，这给产科诊疗和母胎管理带来了新的挑战，特别是在高风险妊娠的管理和分娩方式选择上。</p>
            <p class="agreement-abstract agreement_row_p">基于上述背景，为进一步提升产科诊疗和母胎管理质量，特别是在高风险妊娠、个性化分娩方式选择和精准母胎健康监护等方面的质量，北京市光明慈善基金会发起“产科速讯”学科学术交流项目，项目计划于2025年2月-2025年12月开展，将以专家解读文献、病例解读讨论，学术推文的形式推动标准化和规范化的诊疗，利用创新技术应用产生持续性相关领域的教育，促进产科诊疗领域的医疗服务质量进一步提高，为每一位产妇提供更安全、更高效的医疗保障。</p>
            <p class="agreement-abstract agreement_row_p">为明确双方义务及权利，依据《中华人民共和国民法典》等其他相关法律法规之规定，双方在平等自愿基础之上达成以下一致协议：</p>
            <div>
                <h4>第一条 &nbsp;&nbsp;&nbsp;合同期限</h4>
                <p class="agreement-abstract agreement_row_p">自本协议签署之日起至本项目结束之日止。</p>
            </div>
            <div>
                <h4>第二条 &nbsp;&nbsp;&nbsp;乙方提供的劳务内容</h4>
                <p class="agreement-abstract agreement_row_p">乙方提供的学术活动类型：学术培训活动，通过临床典型案例及疾病治疗最新进展提供线上产科相关医学领域的文献解读和病例解读的宣讲服务内容。</p>
            </div>
            <div>
                <h4>第三条：&nbsp;&nbsp;劳务费用支付及方式</h4>
                <p class="agreement-abstract agreement_row_p">本合同采用按次结算，每次劳务费税后<span class="agreement_underline">&nbsp;&nbsp;￥{{ data.meet_pay_amount }}&nbsp;&nbsp;</span>元整，支付方式经双方协商结算。</p>
            </div>
            <div>
                <h4>第四条：&nbsp;&nbsp;双方的基本权利与义务</h4>
                <p class="agreement-abstract agreement_row_p">1、如乙方严重违反合同约定及法律规定，甲方有权终止协议。</p>
                <p class="agreement-abstract agreement_row_p">2、乙方由于个人原因所发生的疾病以及伤残等意外事故，乙方自行负责。</p>
                <p class="agreement-abstract agreement_row_p">3、乙方应严格遵守意识形态工作管理相关制度。</p>
                <p class="agreement-abstract agreement_row_p">4、双方应严格保守在合作过程中所了解的商业及技术机密，否则应对因此造成的损失承担赔偿。</p>
                <p class="agreement-abstract agreement_row_p">5、在提供服务过程中，涉及采集、收集、记载、保留、加工、转移或以其他方式接触或处理任何个人信息，包括但不限于姓名、性别、年龄、出生日期、身份证号码、联系方式、工作单位、家庭住址、健康状况、宗教信仰、生物识别信息、行踪信息、健康信息、医疗记录及其他可识别的自然人有关的信息等（统称“个人信息”），应遵守与个人信息保护相关的所有适用法律，包括但不限于《中华人民共和国民法典》、《中华人民共和国网络安全法》、《中华人民共和国数据安全法》、《中华人民共和国个人信息保护法》，遵守项目主办方不时更新的隐私保护政策。</p>
                <p class="agreement-abstract agreement_row_p">6、对于在本协议履行过程中收集到的个人敏感信息（包括但不限于乙方身份证号码、家庭住址、银行账户、电话等）应采取保密措施，未经乙方同意，不得收集。</p>
                <p class="agreement-abstract agreement_row_p">7、本协议解除或终止时，乙方应向甲方指定的人员交接工作；并立即停止以甲方名义从事一切活动；交接清晰一切与工作相关的事务。</p>
                <p class="agreement-abstract agreement_row_p">8、乙方应按照甲方要求提供劳务服务，不得弄虚作假。</p>
                <p class="agreement-abstract agreement_row_p">9、乙方保证具有完成劳务服务的专业知识与经验，不得提供虚假履历与身份信息。</p>
                <p class="agreement-abstract agreement_row_p">10、乙方在本项目宣讲过程中所载有肖像的视频、音频、录像及照片等资料，乙方同意甲方在全球范围内免费使用，同意甲方用于学习及科学研究。</p>
                <p class="agreement-abstract agreement_row_p">11、甲方依法为乙方代扣代缴个人所得税，乙方应当如实按照我国税法相关规定进行居民个人综合所得年度汇算申报。</p>
            </div>
            <div>
                <h4>第五条：&nbsp;&nbsp;违约责任</h4>
                <p class="agreement-abstract agreement_row_p">1、乙方未按照合同约定提供劳务，甲方有权减少支付劳务报酬。</p>
                <p class="agreement-abstract agreement_row_p">2、乙方不履行劳务的，甲方有权不予支付劳务报酬。</p>
            </div>
            <div>
                <h4>第六条：&nbsp;&nbsp;违约责任</h4>
                <p class="agreement-abstract agreement_row_p">1、双方就解除本协议协商一致的；</p>
                <p class="agreement-abstract agreement_row_p">2、乙方专业能力无法完成合同约定内容的。</p>
                <p class="agreement-abstract agreement_row_p">3、因不可抗力或其他原因致使本协议无法继续履行的。</p>
            </div>
            <div>
                <h4>第七条：&nbsp;&nbsp;<span style="font-weight: normal;">本协议如有未尽事宜，双方另行签订补充协议，补充协议与本协议具有同等法律效力。</span></h4>
            </div>
            <div>
                <h4>第八条：&nbsp;&nbsp;<span style="font-weight: normal;">双方因本协议发生争议首先应友好协商解决，协商不成的，均可向甲方所在地人民法院诉讼解决。</span></h4>
            </div>
            <div>
                <h4>第九条：&nbsp;&nbsp;<span style="font-weight: normal;">本协议一式两份，甲、乙双方各执一份，经甲方盖章乙方签字之日起生效。</span></h4>
                <h4>所需附件：乙方需提供本人身份证复印件、医师资格证书/所属医疗机构胸牌。</h4>
            </div>
            <div class="agreement_row_p">
                以下无正文。
            </div>
        </div>
        <div class="agreement_sign_info">
            <div class="agreemtn_sign_them">
                <div class="agreement_sign_name"><span>甲方：</span>{{ data.agreement_company_name }}</div>
                <div class="agreement_sign_date">{{ $tools.getDate(data.meet_sign_time, "yyyy年MM月dd日") }}</div>
            </div>
            <div class="agreemtn_sign_owner">
                <div class="agreement_sign_name">
                    <span>乙方：</span>
                    <customButton @click="doSignName(0)" v-if="!(data.meet_sign_name || signData[0])">
                        <div>
                            <span>签名</span>
                        </div>
                    </customButton>
                    <img :src="data.meet_sign_name?.split(',')[0] || this.signData[0]" @click="doSignName(0)" v-else alt="">
                </div>
                <div class="agreement_sign_date">{{ $tools.getDate(data.meet_sign_time, "yyyy年MM月dd日") }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import customButton from "@/components/unit/customButton"
export default {
    name: "commonAgreement",
    props: {
        agreementData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        agreementFields: {
            type: Array,
            default: () => {
                return []
            }
        },
        signData: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            showSignName: false,
            agreementHTML: '',
            data: {},
            config: {
                nullText: /<(div|p)\s*class=[\s\w\"]*><\/(div|p)>/g,
            },
        }
    },
    mounted() {
        // this.initData(this.agreementData,this.agreementFields)
        this.data = this.agreementData;
        this.$emit("initScroll")
    },
    components: {
        customButton,
    },
    methods: {
        initData(data, agreementFields) {
            this.data = data;
            let html = this.data.project_agreement?.replace(this.config.nullText, "") || ""
            html = html.replace(/{{<\/*[\w]+>/, "{{") //{{<span>current_day}} ==>{{current_day}}
            html = html.replace(/<\/*[\w]+>}}/, "}}") //{{current_day</span>}} ==>{{current_day}}
            for (let item of agreementFields) {
                let reg = new RegExp(`{{${item.field}}}`, "g")
                let val = this.data[item.field]
                if (item.use_format) {
                    try {
                        val = eval(`${item.use_format}()`)
                    } catch (err) {
                        console.log(err)
                    }
                }
                html = html.replace(reg, val)
            }
            this.agreementHTML = html;
            this.$emit("initScroll")
        },
        verifyData() {
            if (!this.signData[0]) {
                this.$tips.error({ text: "请先签名" })
                return false;
            }
            return true;
        },
        doSignName(index) {
            this.$emit("doSignName", index)
        },
    }
}
</script>
<style>.commonAgreement_contaier {
    width: 100%;
    height: 100%;
}

.agreement_main {
    height: 100%;
    overflow: hidden;
}

.agreement_main div.agreement_underline {
    border-bottom: 1px solid #000;
}

.agreement_main h1 {
    width: 100%;
    text-align: center;
    font-size: 6vw;
}

.agreement_main h3 {
    width: 100%;
    text-align: center;
    font-size: 5vw;
    margin: 3vw 0;
}

.agreement_main b {
    font-weight: 500;
}

.agreement_main p {
    display: block;
    /* margin-block-start: 0em;
    margin-block-end: 0em;
    margin-inline-start: 0px;
    margin-inline-end: 0px; */
}

.agreement_main p,
.agreement_main div {
    line-height: 6.8vw;
    width: 100%;
    /* text-indent: 8vw;; */
}

.agreement_sign_info {
    display: flex;
}

.agreement_sign_info>div {
    flex: 1 0 0;
    margin-top: 6vw;
}

.agreement_sign_name {
    height: 16vw;
    display: flex;
    align-items: center;
}

.agreement_sign_name span {
    white-space: nowrap;
}
.agreement_sign_name img {
    width: 24vw;
    height: auto;
}
.agreement-abstract {
  text-indent: 2em;
}
.agreement_row_p{
    margin: 2vw 0;
    margin-block-start: 2vw !important;
    margin-block-end: 2vw !important;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
</style>